import type { FunctionComponent } from 'preact';
import { useRef } from 'preact/hooks';

import { SearchBoxDialogName } from 'Components/names';
import type { Props as SearchBoxProps } from 'Components/searchBox/searchBox';
import type { TemplateResult } from 'Components/types';
import { focusGuardProps, useAutoFocus } from 'Core/hooks/autofocus';
import { usePopup } from 'Core/hooks/index';

import SearchBox from '../searchBox/searchBox';

const SearchBoxDialog: FunctionComponent<SearchBoxProps> = (props) => {
  const { opened, close } = usePopup(SearchBoxDialogName);

  const contentRef = useRef<HTMLDivElement>(null);
  const inputRef = useRef<HTMLInputElement>(null);
  const focusAutoFocusInside = useAutoFocus(contentRef, inputRef, opened);

  if (!opened) {
    return null;
  }

  const onSubmit = () => {
    close();
    props.onSubmit?.();
  };

  const searchBoxProps = {
    ...props,
    name: SearchBoxDialogName,
    inputRef,
    onSubmit,
    extraParams: { close },
    disableAutoRequest: true,
    enableAutoFocus: true,
  };

  return (
    <>
      <div {...focusGuardProps} onFocus={focusAutoFocusInside} />
      <div ref={contentRef} data-focus-lock-disabled="false">
        <SearchBox {...searchBoxProps} />
      </div>
      <div {...focusGuardProps} onFocus={focusAutoFocusInside} />
    </>
  ) as TemplateResult;
};

export default SearchBoxDialog;
